import { render, staticRenderFns } from "./Fundermax.vue?vue&type=template&id=1bdd5079&scoped=true"
import script from "./Fundermax.vue?vue&type=script&lang=js"
export * from "./Fundermax.vue?vue&type=script&lang=js"
import style0 from "./Fundermax.vue?vue&type=style&index=0&id=1bdd5079&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdd5079",
  null
  
)

export default component.exports